import {Option} from 'platform/components';

import {isNil} from 'ramda';

import {CustomerResponseBodyV2} from '@dms/api/customer';

import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

import {getCustomerName} from './getCustomerName';

export const getOptionsFromCustomersAsSupplier = (
  customersAsSuppliers: CustomerResponseBodyV2[] | Nullish
): Option[] => {
  if (isNil(customersAsSuppliers)) {
    return [];
  }

  return customersAsSuppliers.map((customersAsSupplier) => ({
    label: getCustomerName(customersAsSupplier) ?? EMPTY_PLACEHOLDER,
    value: customersAsSupplier.id,
  }));
};
